

export class BranchDetailsRouteGroupInput implements IBranchDetailsRouteGroupInput {
    /** The auto-generated id of the vehicle details master */
    branchDetailId!: number;

    constructor(data?: IBranchDetailsRouteGroupInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.branchDetailId = _data["branchDetailId"];
        }
    }

    static fromJS(data: any): BranchDetailsRouteGroupInput {
        data = typeof data === 'object' ? data : {};
        let result = new BranchDetailsRouteGroupInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["branchDetailId"] = this.branchDetailId;
        return data; 
    }
}

export interface IBranchDetailsRouteGroupInput {
    /** The auto-generated id of the vehicle details master */
    branchDetailId: number;
}

